module.exports = __webpack_public_path__ + "static/media/phone.754b0a15.svg";